

//publicar
//local
// const BaseUrl = 'http://localhost:54188/api/'

//beta
// const BaseUrl = 'https://beta-apisupport.easyclocking.com/api/'


//live
const BaseUrl = 'https://apisupport.easyclocking.com/api/'


export default BaseUrl;


// WEBPACK FOOTER //
// ./src/utils/api.js